<template>
  <div id="mapContainer" class="mapContainer">
    <div id="vehiclesupervisorMap" class="map"></div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import { getMapSeting } from "@/api/ai.js";
import Vue from "vue";
import { fromLonLat } from "ol/proj";
import Map from "ol/Map";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import Point from "ol/geom/Point";
import Cluster from "ol/source/Cluster";
import { Tile as TileLayer } from "ol/layer";
import { DoubleClickZoom, DragPan, MouseWheelZoom } from "ol/interaction";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
import { XYZ } from "ol/source";
import View from "ol/View";
import GeoJSON from "ol/format/GeoJSON.js";
// import GIS_MAP from "@/assets/JSON/gisMap";
import { TileSuperMapRest } from "@supermap/iclient-ol";
import { defaults as defaultControls } from "ol/control";
import { Style, Icon, Stroke, Circle, Fill, Text } from "ol/style";
import infoWindow from "./infoWindow";
import checkOverlapMixins from "../../components/mixins/checkOverlap";

export default {
  mixins: [checkOverlapMixins],
  props: {
    areaInfoList: {
      type: Array,
      default: [],
    },
    rectBounds: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // 地图对象
      map: null,
      // 特效图
      imgLayer: null,
      // 是否是省级单位
      isProvinceLevel: true,
      // 市边界
      boundaryLayer: null,
      // 图标层
      iconLayer: null,
      marker: null,
      cloneFeature: [],
      selectFeature: null,
      //使用率、兑付率弹窗
      infoWindow: infoWindow,
      winCotent: null,
      winTooltip: null,
      // 边界样式
      styles: {
        boundary: new Style({
          fill: new Fill({
            color: "rgba(0,0,0,0)",
          }),
          stroke: new Stroke({
            color: "RGBA(255, 255, 255, 0)",
            width: 2,
          }),
        }),
      },
      layers: {
        baseLayer: null,
      },
      mapSeting: null,
    };
  },
  mounted() {
    this.initMap();
  },
  watch: {
    // areaInfoList() {
    //   this.setInfoToFeature();
    // },
  },
  computed: {},
  methods: {
    /**
     * @description: 切换图层
     * @cityCode {String} 城市编码
     * @return {void}
     */
    async addProvince(city = "410000000") {
      console.log("city :>> ", city);
      let _this = this;
      let params = {
        areaCode: city,
        largeScreenType: "vehiclesupervisor",
      };
      this.mapSeting = await getMapSeting(params);
      // if (!GIS_MAP[city]) {
      if (!this.mapSeting || !this.mapSeting.specialEffectsUrl) {
        console.log("失败 :>> ", "未找到区域图层");
        this.map.removeLayer(this.layers.baseLayer);
        return;
      } else {
        this.map.getView().setZoom(this.mapSeting.zoom);
        this.map.getView().setCenter(this.mapSeting.center.split(","));
        // this.map.getView().setZoom(GIS_MAP[city].vehiclesupervisorZoom);
        // this.map.getView().setCenter(GIS_MAP[city].vehiclesupervisorCenter);
        this.map.removeLayer(this.layers.baseLayer);
        this.map.removeLayer(this.imgLayer);
        this.iconLayer.getSource().clear();
        this.map.removeLayer(this.boundaryLayer);
        this.map.getOverlays().clear();

        this.imgLayer = new TileLayer({
          source: new TileSuperMapRest({
            // url: _this.$utils.formatUrl(GIS_MAP[city].vehiclesupervisorUrl),
            url: _this.$utils.formatUrl(_this.mapSeting.specialEffectsUrl),
            cacheEnabled: true,
          }),
          isGroup: true,
          name: "高清影像图",
        });

        let needUrl = _this.$utils.getGeoJsonUrl(_this.mapSeting.geoJsonUrl);
        // 获取geojson
        this.$ajax
          .get(needUrl) // 假设文件位于静态资源目录
          .then((response) => {
            const geojsonFormat = new GeoJSON();
            let features = geojsonFormat.readFeatures(response.data);
            this.boundaryLayer = new VectorLayer({
              source: new VectorSource({
                features: features,
              }),
              // zIndex: 6
            });
            this.boundaryLayer
              .getSource()
              .getFeatures()
              .forEach((f) => {
                f.set("type", "boundary");
                f.set("keyId", `boundary_${f.get("adcode")}`);
                f.setStyle(this.styles["boundary"].clone());
                const cloneF = new Feature(f.getProperties());
                cloneF.setStyle(f.getStyle().clone());
                this.cloneFeature.push(cloneF);
              });
            this.map.addLayer(this.boundaryLayer);
            this.addCiyMarker();
          });
        this.map.addLayer(this.imgLayer);
      }
    },
    // 把接口详情信息存入feature
    setInfoToFeature() {
      const that = this;
      const source = that.boundaryLayer.getSource();
      const features = source.getFeatures();
      const areaData = [];
      this.areaInfoList.forEach((d) => {
        areaData[d.areaName] = d;
      });
      features.forEach((f) => {
        if (areaData[f.get("name")]) {
          f.set("obj", areaData[f.get("name")]);
        }
      });
    },
    deepCloneFeature(feature) {
      // 创建新的特征，使用原始特征的几何
      const clonedFeature = new Feature({
        geometry: feature.getGeometry().clone(),
      });

      // 克隆特征的样式
      const originalStyle = feature.getStyle();
      const clonedStyle = originalStyle.clone();

      clonedFeature.setStyle(clonedStyle);
      // 克隆特征的属性
      const properties = feature.getProperties();
      const clonedProperties = {};
      for (const key in properties) {
        if (properties.hasOwnProperty(key)) {
          clonedProperties[key] = properties[key];
        }
      }
      clonedFeature.setProperties(clonedProperties);

      return clonedFeature;
    },
    // 添加地图区域图标
    addCiyMarker() {
      // 获取经纬度
      purchaseAllowanceApi
        .getAreaLonAndLat(this.$store.state.activeRegionObj.areaCode)
        .then((res) => {
          let lonAndLatList = res || [];
          const features = this.boundaryLayer.getSource().getFeatures();
          for (let i = 0; i < features.length; i++) {
            for (let j = 0; j < lonAndLatList.length; j++) {
              if (features[i].get("adcode") == lonAndLatList[j].areaId) {
                features[i].set("oldLonAndLat", [
                  lonAndLatList[j].lon,
                  lonAndLatList[j].lat,
                ]);
                features[i].set("lonAndLat", [
                  lonAndLatList[j].longitude,
                  lonAndLatList[j].latitude,
                ]);
                break;
              }
            }
          }
          // 对坐标点 进行纬度排序（从北往南）
          let sortFeatures = [...features].sort(
            (a, b) => b.get("lonAndLat")[1] - a.get("lonAndLat")[1]
          );
          let featuresZindex = 10;
          sortFeatures.forEach((f) => {
            featuresZindex++;
            const iconFeature = new Feature({
              geometry: new Point(f.get("lonAndLat")),
              name: f.get("name"),
            });
            iconFeature.set("adcode", f.get("adcode"));
            iconFeature.set("keyId", `city_${f.get("adcode")}`);
            iconFeature.set("lonAndLat", f.get("lonAndLat"));
            if (
              require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${f.get(
                "name"
              )}.png`)
            ) {
              iconFeature.setStyle(
                new Style({
                  image: new Icon({
                    src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${f.get(
                      "name"
                    )}.png`),
                    scale: 1,
                    anchor: [0.5, 1],
                    // displacement: [10, -20]
                    displacement: [0, 0],
                  }),
                  zIndex: featuresZindex,
                })
              );
            }
            const cloneF = this.deepCloneFeature(iconFeature);
            this.cloneFeature.push(cloneF);
            // this.iconLayer.getSource().addFeature(iconFeature);
          });
        });
    },
    resetStyle(feature) {
      if (feature) {
        this.cloneFeature.forEach((f) => {
          if (f.get("keyId") === feature.get("keyId")) {
            feature.setStyle(f.getStyle().clone());
          }
        });
        const iconFeatures = this.iconLayer.getSource().getFeatures();
        let zindex = 10;
        for (let i = 0; i < iconFeatures.length; i++) {
          if (iconFeatures[i].get("adcode") == feature.get("adcode")) {
            iconFeatures[i].setStyle(
              new Style({
                image: new Icon({
                  src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${feature.get(
                    "name"
                  )}.png`),
                  scale: 1,
                  anchor: [0.5, 1],
                  // displacement: [10, -20]
                  displacement: [0, 0],
                }),
                zIndex: zindex,
              })
            );
          }
        }
      }
    },
    checkedIconFeatures(feature) {
      let iconFeatures = this.iconLayer.getSource().getFeatures();
      let zIndex = 10;
      for (let i = 0; i < iconFeatures.length; i++) {
        if (iconFeatures[i].get("adcode") == feature.get("adcode")) {
          iconFeatures[i].setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${feature.get(
                  "name"
                )}-c.png`),
                scale: 1,
                anchor: [0.5, 1],
                // displacement: [10, -30]
                displacement: [0, -16],
              }),
              zIndex: 200,
            })
          );
        } else {
          iconFeatures[i].setStyle(
            new Style({
              image: new Icon({
                src: require(`@/assets/images/governmentAffairs/vehiclesupervisor/map/${iconFeatures[
                  i
                ].get("name")}.png`),
                scale: 1,
                anchor: [0.5, 1],
                // displacement: [10, -20]
                displacement: [0, 0],
              }),
              zIndex: zIndex,
            })
          );
        }
      }
    },
    mapClick(feature, coordinates) {
      if (feature && feature.get("adcode")) {
        let _this = this;
        const features = this.boundaryLayer.getSource().getFeatures();
        // const iconFeatures = this.iconLayer.getSource().getFeatures();
        features.forEach((f) => {
          if (feature.get("adcode") === f.get("adcode")) {
            // const fill = f.getStyle().getFill();
            // const stroke = f.getStyle().getStroke();
            // fill.setColor("RGBA(0, 176, 12, 1)");
            // stroke.setColor("RGBA(255, 255, 255, 1)");
            // f.setStyle(f.getStyle());
            this.checkedIconFeatures(feature);
            this.selectFeature = f;
          } else {
            // this.resetStyle(f);
          }
        });
        if (this.selectFeature) {
          if (this.infoWindow) {
            const iconFeature = new Feature({
              geometry: new Point(_this.mapSeting.center.split(",")),
              name: '固定feature',
            });
            iconFeature.set("lonAndLat", _this.mapSeting.center.split(","));
            this.openWindow(iconFeature, this.infoWindow, coordinates);
          }
        } else {
          this.closeWindow();
        }
      } else {
        this.closeWindow();
        this.resetStyle(this.selectFeature);
      }
    },
    // 改变要素样式
    closeWindow() {
      if (this.winCotent && this.winCotent.$el.parentNode) {
        this.winCotent.$el.parentNode.removeChild(this.winCotent.$el);
      }
    },
    // 使用率、兑付率弹窗
    openWindow(feature, infoWindow, tooltipCoord) {
      if (feature) {
        const obj = this.areaInfoList[0];
        const Content = Vue.extend(infoWindow);
        if (this.winCotent) {
          if (this.winCotent.$el.parentNode) {
            this.winCotent.$el.parentNode.removeChild(this.winCotent.$el);
          }
        }
        this.winCotent = new Content({
          propsData: {
            infoObj: { name: obj.areaName, ...obj },
            vmm: this,
          },
        }).$mount();
        if (this.winTooltip) {
          this.map.removeOverlay(this.winTooltip);
          this.winTooltip = null;
        }
        // this.winTooltip = new Overlay({
        //   element: this.winCotent.$el,
        //   // offset: [-80, -200],
        //   offset: feature.values_.lonAndLat[0] > 115 ? [-30, -30] : [42, -70],
        //   positioning: feature.values_.lonAndLat[0] > 115 ? 'center-right' : 'center-left',
        //   insertFirst: true,
        //   stopEvent: true,
        // })
        let pixel = this.map.getPixelFromCoordinate(feature.values_.lonAndLat); // 地理坐标转像素坐标
        let positioning = "center-right";
        let offset = [18, 0];
        this.winTooltip = new Overlay({
          element: this.winCotent.$el,
          positioning: positioning,
          offset: offset,
          insertFirst: true,
          stopEvent: true,
        });
        this.winTooltip.getElement().parentNode.style.zIndex = 1020;
        this.map.addOverlay(this.winTooltip);
        this.winTooltip.setPosition(feature.values_.lonAndLat);
        let popupElement = this.winTooltip.getElement();
        let popupWidth = popupElement.offsetWidth;
        let popupHeight = popupElement.offsetHeight;
        let popupLeft = pixel[0] + this.winTooltip.values_.offset[0];
        let popupTop = pixel[1] + this.winTooltip.values_.offset[1];
        // 检测是否与四周矩形重叠
        let isOverlap = this.checkOverlap(
          popupLeft,
          popupTop,
          popupWidth,
          popupHeight,
          this.rectBounds
        );
        if (isOverlap) {
          this.adjustPopupPosition(
            this.winTooltip,
            pixel,
            popupWidth,
            popupHeight,
            this.rectBounds
          );
        } else {
          this.winTooltip.setPosition(feature.values_.lonAndLat);
        }
      } else {
        this.closeWindow();
      }
    },
    // 鼠标悬浮各区域
    pointMove(feature, coordinates) {
      if (feature && feature.get("adcode")) {
        if (this.infoWindow) {
          this.openWindow(feature, this.infoWindow, coordinates);
        }
      } else {
        this.closeWindow();
      }
    },
    initMap() {
      let that = this;
      this.iconLayer = new VectorLayer({
        // declutter: false, // 发生碰撞时清理掉与其重叠的 feature（不能实现避让）
        zIndex: 2,
        source: new VectorSource(),
      });
      this.map = new Map({
        target: "vehiclesupervisorMap",
        layers: [
          new TileLayer({
            source: new XYZ({
              url: "https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=1d109683f4d84198e37a38c442d68311",
            }),
            isGroup: true,
            visible: false,
            name: "天地图路网",
          }),
          new TileLayer({
            source: new XYZ({
              url: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=1d109683f4d84198e37a38c442d68311",
            }),
            visible: false,
            isGroup: true,
            name: "天地图文字标注",
          }),
          this.iconLayer,
        ],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: [115.86, 33.0],
          zoom: 7.4,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 3.5,
        }),
      });
      // 禁用拖动
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DragPan) {
          interaction.setActive(false);
        }
      });
      // 禁用双击缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof DoubleClickZoom) {
          interaction.setActive(false);
        }
      });
      // 禁用滚轮缩放
      this.map.getInteractions().forEach(function (interaction) {
        if (interaction instanceof MouseWheelZoom) {
          interaction.setActive(false);
        }
      });
      that.map.on("pointermove", function (evt) {
        var pixel = that.map.getEventPixel(evt.originalEvent);
        const feature = that.map.forEachFeatureAtPixel(
          pixel,
          function (feature) {
            return feature;
          }
        );
        that.mapClick(feature, evt.coordinate);
      });
      // that.map.on('pointermove', function (evt) {
      //   var pixel = that.map.getEventPixel(evt.originalEvent)
      //   const feature = that.map.forEachFeatureAtPixel(
      //     pixel,
      //     function (feature) {
      //       return feature
      //     },
      //     {
      //       layerFilter: function (layer) {
      //         return layer == that.boundaryLayer
      //       }
      //     }
      //   )
      //   that.pointMove(feature, evt.coordinate)
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.mapContainer {
  float: right;
  width: 100%;
  height: 100%;
  position: relative;
  ::v-deep {
    .ol-attribution.ol-unselectable.ol-control.ol-collapsed {
      display: none;
    }
    .ol-control {
      display: none;
    }
  }
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.ol-rotate {
  display: none;
}
</style>
